import { useSyncExternalStore } from 'react';
import { authorizationStore, setAuthorizationOrganization, useRuntime } from '../../../..';
import { authorizationOrganizationFakes } from '../../../../fakes/types/authorization-organization-fakes';
// This hook is used to get the user's authorization organizations and the selected organization
// It uses the useRuntime hook to get the runtime and
// the useUserAuthorizationOrganizationsEventListener and useUserAuthorizationOrganizationSelectedEventListener hooks
// to listen to the events that will be triggered when the user's authorization organizations are retrieved and
// when the user selects an organization, respectively.
// It will use fake data if the runtime is in fake mode for authorization organizations.
export function useUserAuthorizationOrganizations() {
    const authorization = useSyncExternalStore(authorizationStore.subscribe, authorizationStore.getSnapshot);
    const runtime = useRuntime();
    const userAuthorizationOrganizations = runtime.fakes ? authorizationOrganizationFakes : authorization.organizations;
    // Represents the selected authorization organization for the user.
    // It is determined based on the user's authorization organizations and the currently selected authorization organization.
    // If the currently selected authorization organization is found in the user's authorization organizations, it is returned.
    // Otherwise, if there is only one user authorization organization, it is returned.
    // If none of the above conditions are met, it is set to undefined.
    const selectedAuthorizationOrganization = userAuthorizationOrganizations?.find(org => org.id === authorization.organization?.id)
        || (userAuthorizationOrganizations?.length === 1 ? userAuthorizationOrganizations[0] : undefined);
    if (userAuthorizationOrganizations?.length === 1 &&
        (authorization.organization === null || authorization.organization === undefined) &&
        selectedAuthorizationOrganization !== null &&
        selectedAuthorizationOrganization !== undefined) {
        setAuthorizationOrganization(selectedAuthorizationOrganization);
    }
    return { userAuthorizationOrganizations, selectedAuthorizationOrganization };
}
